import { initialState as userInitialState } from '@chegg-wt/core/state/user/reducer'
import { UserRoles, MIGRATION_STATUSES } from '../constants/user'

export const getUserPreloadedState = (userRole: string) => {
  const role = userRole || ''
  const isPro = role === UserRoles.PRO_USER
  return {
    ...userInitialState,
    user: {
      ...userInitialState.user,
      role,
      paidMember: isPro,
    },
  }
}

export const migrationStatusToConstant = (status) => {
  switch (status) {
    case 0:
    case 1:
      return MIGRATION_STATUSES.inProgress
    case 2:
      return MIGRATION_STATUSES.complete
    default:
      return MIGRATION_STATUSES.other
  }
}
